import { render, staticRenderFns } from "./AdminDomainsForm.vue?vue&type=template&id=20148a67&"
import script from "./AdminDomainsForm.vue?vue&type=script&lang=js&"
export * from "./AdminDomainsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports